import React, { FC } from 'react';
import { Badge } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as NotificationsIcon } from '../../../../assets/images/NotificationsIcon.svg';
import { ThemeSwitcher } from '../ThemeSwitcher';
import { isBrizTvFeatureEnabled } from '../../../../constants/configuration';
import { BasicButton } from '../../buttons/BasicButton/BasicButton';
import { ReactComponent as BrizTVIcon } from '../../../../assets/images/BrizTvHeader.svg';
import { UserInfoBlock } from '../../../homeParts/UserInfoBlock';

interface NavBarProps {
  isAuth: boolean;
  handleNotification: () => void;
  isNewNotification: boolean;
  handleBrizTv: () => void;
  handleCallback: () => void;
  width: number;
}

export const NavBar: FC<NavBarProps> = ({
  isAuth,
  handleNotification,
  isNewNotification,
  handleBrizTv,
  handleCallback,
  width,
}) => {
  const { t } = useTranslation();

  return (
    <nav>
      <ul className="navbar">
        <ThemeSwitcher />
        <BasicButton handleClick={handleCallback}>
          <li className="hover">{t('header.callMeBack')}</li>
        </BasicButton>
        {isAuth ? (
          <>
            <BasicButton handleClick={handleNotification}>
              <li className="hover">
                <NotificationsIcon />
                <Badge className="custom-badge text" color="error" variant="dot" invisible={!isNewNotification}>
                  {t('header.notification')}
                </Badge>
              </li>
            </BasicButton>
            {isBrizTvFeatureEnabled && (
              <div className="navbar__brizTV">
                <BasicButton handleClick={handleBrizTv}>
                  <BrizTVIcon />
                  <span>{t('header.brizTv')}</span>
                </BasicButton>
              </div>
            )}
            <UserInfoBlock width={width} />
          </>
        ) : null}
      </ul>
    </nav>
  );
};
